import React, { PureComponent, Fragment } from 'preact/compat';
import PropTypes from 'prop-types';
import { List } from 'rmwc/List';
import { getJobLocale } from '../../../lib/translate';

import AccordionListItem from './AccordionListItem';

import withData from '../../jobs/withData';

class Jobs extends PureComponent {
  renderJobs() {
    return this.props.jobs.map(job => (
      <Fragment key={job.id}>
        <AccordionListItem
          job={job}
          locales={this.props.locales}
          locale={getJobLocale(job)}
        />
      </Fragment>
    ));
  }

  render() {
    return (
      <List twoLine>
        {this.renderJobs()}
      </List>
    );
  }
}

Jobs.propTypes = {
  jobs: PropTypes.arrayOf(PropTypes.object),
  locales: PropTypes.arrayOf(PropTypes.string),
};

Jobs.defaultProps = {
  jobs: [{}],
  locales: [],
};

export default withData(Jobs);
